<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WhiteBlancLayout',
};
</script>

<style scoped>

</style>
